/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
import React from 'react';
//material
import DataLastUpdated from 'material/callout/datalastupdated/datalastupdated_container';
import Link from 'material/ctas/link/link_container';
import Icon from 'material/graphic/icon/icon';
// styles
import injectSheet from 'react-jss';
import styles from 'pages/dashboard/reports/reporthelpers/reporthelpers_styles';



/* ========== ~~~~~~~~~~ REPORT HELPERS : CHILD ~~~~~~~~~~ ========== */
// PRESENTATIONAL COMPONENT
// receives app state & actions as props from parent "_container" component
// this child component handles local state and uses props passed from parent to read/write application state when necessary
const ReportHelpers = props => (
    <div className={`reporthelpers ${props.classes.reporthelpers}`}>
        <Link type={`internal`} behavior={`back`} name={`backtoreports`} text={`Back to all reports`} color={`primary`} action={`dashboard/reports`} icon={<Icon name={`hand-point-left`} />} />
        <DataLastUpdated />
    </div>
);



/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
export default injectSheet(styles)(ReportHelpers);
